module.exports = __webpack_public_path__ + "img/sPrinCrime_350x350.21917718.jpg";